// extracted by mini-css-extract-plugin
export default {"month-card":"styles_month-card__8jfWa","date":"styles_date__Nje1+","add-button":"styles_add-button__4nkqZ","icon":"styles_icon__KAi1n"};